import { MarketCountryCode } from '@axo/shared/types';
import { AxoFormContextOptions } from '../../../../context/AxoForm/AxoForm.types';
import type { DenmarkFormData } from '../FormData.dk.types';
import { getTrackingData } from './getTrackingData';
import { mutators } from './mutators';
import { steps } from './steps';

const axoFormContextProviderOptions = {
  marketCountry: MarketCountryCode.Denmark,
  getTrackingData: getTrackingData,
  mutators: mutators,
  initialSnapshotStepName: steps[0].name,
} satisfies AxoFormContextOptions<DenmarkFormData>;

export default axoFormContextProviderOptions;
